import { typography as altonTheme } from './alton'
import { typography as doelgerTheme } from './doelger'
import { typography as judahTheme } from './judah'
import { typography as oceanBeachTheme } from './ocean-beach'
import { typography as systemTheme } from './system'
import { TypographyOptions } from './types'
import { typography as wordpressKubrickTheme } from './wordpress-kubrick'

export enum TypographyTheme {
  alton = 'alton',
  doelger = 'doelger',
  system = 'system',
  judah = 'judah',
  oceanBeach = 'oceanBeach',
  wordpressKubrick = 'wordpressKubrick',
}

export const typographyThemes: Record<TypographyTheme, TypographyOptions> = {
  [TypographyTheme.system]: systemTheme,
  [TypographyTheme.alton]: altonTheme,
  [TypographyTheme.doelger]: doelgerTheme,
  [TypographyTheme.judah]: judahTheme,
  [TypographyTheme.oceanBeach]: oceanBeachTheme,
  [TypographyTheme.wordpressKubrick]: wordpressKubrickTheme,
}
